import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL || "http://localhost:8000";

export const api = axios.create({ baseURL: `${BASE}/api` });

export async function fetchItems(resource, params = {}) {
  const { data } = await api.get(`/${resource}`, { params });
  // Handle both {posts:[]} and {items:[]} and plain arrays
  return data[resource] || data.items || data || [];
}

// Same call, but keeps the pagination envelope ({ posts, total, has_more }).
export async function fetchPage(resource, params = {}) {
  const { data } = await api.get(`/${resource}`, { params });
  const items = data[resource] || data.items || (Array.isArray(data) ? data : []);
  return {
    items: Array.isArray(items) ? items : [],
    total: data.total ?? items.length,
    hasMore: data.has_more ?? false,
  };
}

export async function createItem(resource, payload) {
  const { data } = await api.post(`/${resource}`, payload);
  return data;
}
